import importedMetaData from "$public/metadata.json";
export function isMetaPrimitive(data) {
    return data.hasOwnProperty("type") && typeof data["type"] === "string";
}
export function isMetaEnum(data) {
    return data.hasOwnProperty("type") && Array.isArray(data["type"]);
}
export const metadata = importedMetaData;
